import { SVGProps } from 'react';

const SvgPersonArrow = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 9" {...props}>
        <path d="M8.333 6.722H6.111v1.111h2.222v1.111L10 7.278 8.333 5.61v1.111ZM4.444.056c-1.222 0-2.222 1-2.222 2.222s1 2.222 2.222 2.222c1.223 0 2.223-1 2.223-2.222S5.667.056 4.444.056Zm0 1.11c.612 0 1.112.5 1.112 1.112 0 .61-.5 1.11-1.112 1.11-.61 0-1.11-.5-1.11-1.11 0-.611.5-1.111 1.11-1.111Zm0 3.89C2.944 5.056 0 5.778 0 7.278v1.666h5.278C5.11 8.611 5.056 8.278 5 7.89H1.056v-.611c0-.334 1.722-1.167 3.388-1.167.278 0 .556.056.834.056.166-.334.333-.667.61-.945a7.673 7.673 0 0 0-1.444-.166Z" />
    </svg>
);
export default SvgPersonArrow;
